import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "local-time" }

import { computed, inject } from 'vue';

import { CONSTANTS } from '@exchange/libs/utils/constants/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'LocalTime',
  props: {
  time: {
    type: [Date, String, Number],
    required: false,
  },
  format: {
    type: String,
  },
},
  setup(__props) {

const props = __props;

const utcToLocal = inject<(utcDateString: string | Date | number, formatString?: string) => string>('utcToLocal');
const formattedTime = computed(() => (props.time ? utcToLocal?.(props.time, props.format || CONSTANTS.DATE_FORMAT) || '' : ''));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(formattedTime.value), 1))
}
}

})